import { useState, useEffect } from "react";
import { businessIdHeader, businessesHeader, isLoggedIn } from "./Library";

export function BusinessLoader() {
    const [loading, setLoading] = useState(true);
    const [businesses, setBusinesses] = useState([]);
    const [currentBusiness, setCurrentBusiness] = useState(null);

    useEffect(() => {
        async function load() {
            setLoading(true);

            const loggedIn = await isLoggedIn();
            if (!loggedIn) {
                setLoading(false);
                return;
            }

            const storedBusinesses = JSON.parse(sessionStorage.getItem(businessesHeader));
            const storedBusinessId = JSON.parse(sessionStorage.getItem(businessIdHeader));

            setBusinesses(storedBusinesses);

            const found = storedBusinesses.find(b => b.businessId == storedBusinessId);
            setCurrentBusiness(found || null);

            setLoading(false);
        }

        load();
    }, []);

    return {
        loading,
        businesses,
        currentBusiness,
        hasInternalReviews: currentBusiness?.hasInternalReviews ?? null
    };
}
